// INITIAL STATE
// ==========================================================================

export const initialState = {
  currentLayout: 'Main', // 'project' || 'sensitivity'

  // Project
  selectedProjectIds: [],
  projectIds: [],
  projectsById: {},
  selectedCasingIds: [],

  // Sensitivity
  selectedSensitivityIds: [],
  sensitivityIds: [],
  sensitivitiesById: {},

  selectedHScenarioIds: [],
  selectedCdScenarioIds: [],
  selectedDntScenarioIds: [],
  // Settings
  settings: {}
};

export default initialState;
